import { render, staticRenderFns } from "./pesquisaclinica.vue?vue&type=template&id=35958de2"
import script from "./pesquisaclinica.vue?vue&type=script&lang=js"
export * from "./pesquisaclinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports